import { orderStatusList } from "../../constant/constants";
import ApiService from "../../utils/ApiService";
import { formatDisplayDateTime, getParsedNumber } from "../../utils/Common";

const getFormatedOrderListData = (records, page, perPage) => {
  let pageNo = getParsedNumber(page);
  const perPageDoc = getParsedNumber(perPage);
  const startSl = --pageNo * perPageDoc + 1;

  return records.map((record, i) => {
    return {
      key: record._id,
      sl: startSl + i,
      orderId: record._id,
      orderNumber: record.orderNumber,
      customer: `0${record.userId.phone}`,
      orderType: record.orderType || "",
      orderTime: formatDisplayDateTime(record.createdAt),
      paymentType: record.paymentType === 'SSLC' ? 'Online' : 'Counter',
      amount: record.totalPrice.toFixed(2),
      paymentStatus: record.paymentStatus === 1 ? 'Paid' : 'Unpaid',
      orderStatus: record.orderStatus,
      restaurantName: record.restaurantName,
    };
  })
};

export const getPaymentFilters = (paymentStatus) => {
  const filters = {
    paymentStatus: '',
    isPayLater: '',
    hasRefund: '',
    hasRefunded: '',
    hasDiscount: ''
  };

  if (paymentStatus == '1' || paymentStatus == '2') {
    return Object.assign({}, filters, {paymentStatus: paymentStatus == '1' ? 1 : 0})
  }
  
  if (paymentStatus == '3') {
    return Object.assign({}, filters, {paymentStatus: 0, isPayLater: 'YES'})
  }
  
  if (paymentStatus == '5') {
    return Object.assign({}, filters, {hasRefund: 'YES'})
  }
  
  if (paymentStatus == '7') {
    return Object.assign({}, filters, {hasRefunded: 'YES'})
  }

  if (paymentStatus == '6') {
    return Object.assign({}, filters, {hasDiscount: 'YES'})
  }

  return filters;
};

export const getOrderList = async (filters, token) => {
  if (filters.orderStatus) {
    filters.orderStatus = orderStatusList.find(item => item.value == filters.orderStatus).label
  }

  const paymentFilters = getPaymentFilters(filters.paymentStatus);

  const params = Object.assign({}, filters, paymentFilters);
  const {payload} = await ApiService.ORDER_LIST_SUPER_ADMIN(params, token);

  const formatedRecords = getFormatedOrderListData(payload.orders, filters.page, filters.perPage);

  return {
    records: formatedRecords,
    pagination: payload.pagination
  };
}

